export const enum AddressType {
  HOME = 'HOME',
  POSTAL = 'POSTAL',
  INVOCE = 'INVOCE',
  EXTERNAL = 'EXTERNAL',
  OTHER = 'OTHER',
  REGISTERED = 'REGISTERED',
}
